import Axios from 'axios';
import Qs from 'qs';

export default {

  // 分区列表
  areaList(
    community_id
  ) {
    return Axios.get('/community/api/admin/carport/subarea', {
      params: {
        community_id
      }
    });
  },

  // 车位分页列表
  listPage(
    community_id,
    garage_id,
    state,
    name,
    car_number,
    sale_state,
    owner_name,
    owner_mobile,
    page,
    limit
  ) {
    let params = {
      community_id,
      state,
      name,
      car_number,
      sale_state,
      owner_name,
      owner_mobile,
      sort: {
        id: 'desc'
      },
      page,
      limit
    };
    if (garage_id) {
      params.garage_id = garage_id;
    }
    return Axios.get('/community/api/admin/carport/parking', {
      params,
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 增加车位分区
  addArea(
    community_id,
    subarea_name,
    carport_num,
    begin_number,
    numbering_rule,
    carport_prefix
  ) {
    let params = {
      community_id,
      subarea_name,
      carport_num,
      begin_number,
      numbering_rule
    };
    if (numbering_rule === 2) {
      params.carport_prefix = carport_prefix;
    }
    return Axios.post('/community/api/admin/carport/batch-subarea', params);
  },

  // 修改车位分区
  updateArea(
    id,
    name
  ) {
    return Axios.patch(`/community/api/admin/carport/update-subarea/${id}`, {
      name
    });
  },

  // 删除车位分区
  delArea(
    id
  ) {
    return Axios.delete(`/community/api/admin/carport/destroy-subarea/${id}`);
  },

  // 修改车位
  update(
    id,
    name
  ) {
    return Axios.patch(`/community/api/admin/carport/update-parking/${id}`, {
      name
    });
  },

  // 启用车位
  enable(
    id
  ) {
    return Axios.patch('/community/api/admin/carport/batch-forbidden', {
      ids: [id],
      state: 1
    });
  },

  // 禁用车位
  disable(
    id
  ) {
    return Axios.patch('/community/api/admin/carport/batch-forbidden', {
      ids: [id],
      state: 2
    });
  },

  // 车位日志
  log(
    id,
    event,
    car_number,
    created_at
  ) {
    return Axios.get(`/community/api/admin/carport/get-parking-log-list/${id}`, {
      params: {
        created_at,
        filter: {
          event,
          car_number
        },
        sort: {
          created_at: 'desc'
        }
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 车位详情
  info(
    id
  ) {
    return Axios.get(`/community/api/admin/carport/parking/${id}`);
  },

  // 设置缴费规则
  setPaymentRule(
    parking_id,
    house_id,
    type,
    period_start,
    tenancy
  ) {
    return Axios.post('/community/api/admin/carport/set-payment-rule', {
      parking_id,
      house_id,
      type,
      period_start,
      tenancy
    });
  },

  // 车辆登记
  register(
    id,
    name,
    sale_state,
    housing_id,
    owner_id,
    car_number,
    period_start,
    tenancy
  ) {
    return Axios.post(`/community/api/admin/carport/register-car/${id}`, {
      name,
      sale_state,
      housing_id,
      owner_id,
      car_number,
      period_start,
      tenancy
    });
  },

  // 变更车牌
  changeNumber(
    id,
    car_number
  ) {
    return Axios.patch(`/community/api/admin/carport/update-car-number/${id}`, {
      car_number
    });
  },

  // 续租
  continueDate(
    id,
    tenancy
  ) {
    return Axios.patch(`/community/api/admin/carport/reletting/${id}`, {
      tenancy
    });
  },

}